module.exports = __webpack_public_path__ + "img/bot_intent_rg_intent.e042bdcb.svg";